import "./sprinkles.css.ts.vanilla.js";
import "./badge.css.ts.vanilla.js";
var _ = "_17szrmd2 _1y2v1nf7u _1y2v1nf89 _1y2v1nf3x", n = "_17szrmd6", f = "_17szrmd4 _17szrmd2 _1y2v1nf7u _1y2v1nf89 _1y2v1nf3x _1y2v1nf5i _1y2v1nf5x _1y2v1nf5r _1y2v1nf1p", y = "_1y2v1nf5e", a = "_1y2v1nf5d _1y2v1nf5m";
export { _ as badge, n as badgeBigNumber, f as badgeNumber, y as badgeWithChildren, a as container };
